/** Shared visual tokens for customer request tracking (display-only). */

export const TRACKING_PAGE_BG = "#F4F7FB";

export const TRACKING_CARD_SX = {
  borderRadius: "14px",
  bgcolor: "background.paper",
  border: "1px solid",
  borderColor: "divider",
  boxShadow: "0 4px 20px rgba(15, 23, 42, 0.06)",
};

export const TRACKING_CARD_BLUE_SX = {
  ...TRACKING_CARD_SX,
  borderColor: "primary.light",
  borderWidth: 2,
};

export const TRACKING_CARD_ORANGE_SX = {
  ...TRACKING_CARD_SX,
  borderColor: "#FFB74D",
  borderWidth: 2,
};

export const TRACKING_CARD_GREEN_SX = {
  ...TRACKING_CARD_SX,
  borderColor: "#81C784",
  borderWidth: 2,
};

export const TRACKING_CARD_PURPLE_SX = {
  ...TRACKING_CARD_SX,
  borderColor: "#B39DDB",
  borderWidth: 2,
};

export const TRACKING_SOFT_ORANGE_BANNER_SX = {
  borderRadius: "12px",
  bgcolor: "#FFF8F0",
  border: "1px solid #FFE0B2",
  color: "#E65100",
};
